import { useState } from "react";
import {
  BsGithub,
  BsTwitter,
  BsFacebook,
  BsInstagram,
  BsDiscord,
  BsLinkedin,
} from "react-icons/bs";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const [copiedDiscord, setCopiedDiscord] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <footer className="footerContainer">
        <div className="footerLeft">
          <Link
            className="iconStyle"
            to={"https://www.linkedin.com/in/lander-de-kesel-982977287/"}
            target="_blank"
          >
            <BsLinkedin size={30} />
          </Link>
          <Link
            className="iconStyle"
            to={"https://github.com/LanderDK"}
            target="_blank"
          >
            <BsGithub size={30} />
          </Link>
          <Link
            className="iconStyle"
            to={"https://twitter.com/landerdekesel"}
            target="_blank"
          >
            <BsTwitter size={30} />
          </Link>
          <Link
            className="iconStyle"
            to={"https://www.instagram.com/landerdekesel/"}
            target="_blank"
          >
            <BsInstagram size={30} />
          </Link>
          <Link
            className="iconStyle"
            to={"https://www.facebook.com/lander.dekesel/"}
            target="_blank"
          >
            <BsFacebook size={30} />
          </Link>
          <CopyToClipboard text="xhop" onCopy={() => setCopiedDiscord(true)}>
            {copiedDiscord ? (
              <BsDiscord
                className="iconStyle"
                data-tooltip-id="discord"
                data-tooltip-content="Copied!"
                size={30}
              />
            ) : (
              <BsDiscord
                className="iconStyle"
                data-tooltip-id="discord"
                data-tooltip-content="xhop"
                size={30}
              />
            )}
          </CopyToClipboard>
          <Tooltip id="discord" />
        </div>
        <div className="footerRight">
          <p>{t("footer.copy", { currentYear: new Date().getFullYear() })}</p>
        </div>
      </footer>
    </>
  );
};
export default Footer;
